import "./CoursesSeminars.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import WeeklyCourses from "./sections/WeeklyCourses";
import SeminarsAndPrivateLessons from "./sections/SeminarsAndPrivateLessons";
import CallToAction from "./sections/CallToAction";
import AktuelleSeminare from "./sections/AktuelleSeminare";
import Footer from "@/reusable_sections/Footer";
export default function CoursesSeminarsPage() {
  return <div>
      <Header />
      <Hero />
      <WeeklyCourses />
      <AktuelleSeminare /> 
      <SeminarsAndPrivateLessons />
      <CallToAction />
      <Footer />
    </div>;
}